import React, { useEffect, useState } from 'react'
import Page1 from './Page1'
import Page2Kids from './Page2Kids'
import PageBigFour from './Pagebigfour'

import { ReactComponent as MyBathroomBig } from '../../../../../assets/pricetopsvg/bathbig.svg'
import { ReactComponent as MyBedroomBig } from '../../../../../assets/pricetopsvg/bedroombig.svg'
import { ReactComponent as MyCosmeticsBig } from '../../../../../assets/pricetopsvg/cosmeticsbig.svg'
import { ReactComponent as MyKidsBig } from '../../../../../assets/pricetopsvg/kidsbig.svg'
import { ReactComponent as MyKitchenBig } from '../../../../../assets/pricetopsvg/kitchenbig.svg'
import { ReactComponent as MyLivingRoomBig } from '../../../../../assets/pricetopsvg/livingroombig.svg'
import { ReactComponent as MyShowcaseBig } from '../../../../../assets/pricetopsvg/showcasebig.svg'

import { ReactComponent as MyKidsLittle } from '../../../../../assets/pricetopsvg/littlepricezarahome/kidslittle.svg'
import { ReactComponent as MyKitchenLittle } from '../../../../../assets/pricetopsvg/littlepricezarahome/kitchenlittle.svg'

import { ReactComponent as Path1 } from '../../../../../assets/zarahome/path1.svg'

import { ReactComponent as Bicakİzi } from '../../../../../assets/zarahome/bicakizi1.svg'

import useOrderStore from 'store/client/orderStore'
import requests from 'service/api'

const L55XPRHOMEH = ({ data, selectColor, bicakIziParams }, ref) => {
  const department = data.department
  const [brand, category, subCategory] = department.split(' / ')
  const [SouthAmerica, setSouthAmerica] = useState(false)
  const [harmacn, setHarmacn] = useState(false)
  const [homeProducts, setHomeProducts] = useState([])
  const [labelLittle, setLabelLittle] = useState('')
  const [x, setx] = useState(7.5)
  const [y, sety] = useState(107.2)
  const [cardType, setcardType] = useState('')

  const { referance } = useOrderStore()

  // 🔹 kategoriye göre xy ayarı
  useEffect(() => {
    if (data.referance.id === '68bf82f53da0868b30dcb666') {
      if (category === 'Bathroom') { setx(7.9); sety(107.4) }
      else if (category === 'Bedroom') { setx(5.4); sety(107.4) }
      else if (category === 'Cosmetics') { setx(4.9); sety(107.4) }
      else if (category === 'Kids') { setx(4.7); sety(107.575) }
      else if (category === 'Kitchen') { setx(4.9); sety(107.4) }
      else if (category === 'Living Room') { setx(6.5); sety(107.4) }
      else if (category === 'Showcase') { setx(4.7); sety(107.4) }
    } else if (data.referance.id === '68bf8d5d2b0a17ff6fc37315') {
      if (category === 'Bathroom') { setx(8); sety(108.6) }
      else if (category === 'Bedroom') { setx(5.3); sety(108.4) }
      else if (category === 'Cosmetics') { setx(5); sety(108.4) }
      else if (category === 'Kids') { setx(4.9); sety(108.6) }
      else if (category === 'Kitchen') { setx(4.9); sety(108.6) }
      else if (category === 'Living Room') { setx(5.9); sety(108.6) }
      else if (category === 'Showcase') { setx(4.8); sety(108.6) }
    }
  }, [category, data.referance.id])

  const renderShape = (category) => {
    switch (category) {
      case 'Bathroom': return <MyBathroomBig style={{ width: '8.7mm', height: 'auto' }} />
      case 'Bedroom': return <MyBedroomBig style={{ width: '7mm', height: 'auto' }} />
      case 'Cosmetics': return <MyCosmeticsBig style={{ width: '7mm', height: '7mm' }} />
      case 'Kids': return <MyKidsBig style={{ width: '7mm', height: 'auto' }} />
      case 'Kitchen': return <MyKitchenBig style={{ width: '7mm', height: 'auto' }} />
      case 'Living Room': return <MyLivingRoomBig style={{ width: '7.3mm', height: 'auto' }} />
      case 'Showcase': return <MyShowcaseBig style={{ width: '7.4mm', height: 'auto' }} />
      default: return <></>
    }
  }

  const renderShape2 = (category) => {
    switch (category) {
      case 'Kids': return <MyKidsLittle style={{ width: '5.4mm', height: 'auto' }} />
      case 'Kitchen': return <MyKitchenLittle style={{ width: '5mm', height: 'auto' }} />
      default: return renderShape(category)
    }
  }

  // 🔹 firma ve label kontrolleri
  useEffect(() => {
    if (data.brandOrderNo && data.brandOrderNo.trim().endsWith('-25')) setSouthAmerica(true)
    else setSouthAmerica(false)

    setLabelLittle(referance?.code || '')
    setHarmacn(data.companyId === '6562742a5b252fdddcc588e7')
    setcardType(data.priceLabel[selectColor]?.cardType || '')

    requests.homeproducts
      .list()
      .then((res) => setHomeProducts(res.data.products))
      .catch(() => {})
  }, [data.brandOrderNo, referance, selectColor, data.priceLabel])

  // 🔹 Grid parametreli render
  const renderWithParams = () => {
    const allLabels = []
    bicakIziParams.forEach((param) => {
      const matchedSizeData = data.priceLabel[selectColor].sizes.find(
        (size) => size.sCode === param.sizeCode
      )
      if (matchedSizeData) {
        for (let i = 0; i < param.value; i++) allLabels.push(matchedSizeData)
      }
    })

    const labelWidth = 52
    const labelHeight = 105
    const gridWidth = 350
    const gridHeight = 330

    const columns = Math.floor(gridWidth / labelWidth)
    const rows = Math.floor(gridHeight / labelHeight)
    const maxLabels = columns * rows
    const labelsToShow = allLabels.slice(0, maxLabels)

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          width: '100%',
          height: '100%',
          background: 'white',
          marginLeft: '47px',
          marginTop: '30px',
        }}
      >
      <Bicakİzi style={{width: '350mm', height: '330mm', position: 'absolute', top: 16, left: 0 }} />
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: `repeat(${columns}, ${labelWidth}mm)`,
            gridTemplateRows: `repeat(${rows}, ${labelHeight}mm)`,
            width: `${gridWidth}mm`,
            height: `${gridHeight}mm`,
            gap: '0mm',
            position: 'relative',
          }}
        >
        {labelsToShow.map((sizeData, index) => (
          <div
            key={index}
            style={{ width: `52mm`, height: `114mm`, position: 'relative'}}
          >
            {labelLittle === 'LABEL9 45X61' && (
              <Page2Kids
       key={index}
                          selectColor={selectColor}
                          barcodeValue={`4${data?.articleNo?.split('/')[0]}${data?.articleNo?.split('/')[1]}${data?.priceLabel[selectColor]?.colorCode}${sizeData.sCode ? sizeData.sCode : ''}`}
                          qrcodeValue={`4${data?.articleNo?.split('/')[0]}${data?.articleNo?.split('/')[1]}${data?.priceLabel[selectColor]?.colorCode}${sizeData.name ? sizeData.name : ''}`}

                          data={data}
                          harmacn={harmacn}
                          homeProducts={homeProducts}
                          renderShape={renderShape2(category)}
                          Path1={Path1}
                          cardType={cardType}
                          SouthAmerica={SouthAmerica}
                          sizeData={sizeData}
                          indo={data?.priceLabel[0]?.sizes}
                          szrgrp={data?.sizeGroup}
                          inx={index}
              
                          x={x}
                          y={y}
 
                          rifd={data.priceLabel[0].rifd}
              />
            )}
            {labelLittle === 'LABEL9' && (
              <Page1
            key={ index}
                            selectColor={selectColor}
                            barcodeValue={`4${data?.articleNo?.split('/')[0]}${data?.articleNo?.split('/')[1]}${data?.priceLabel[selectColor]?.colorCode}${sizeData.sCode ? sizeData.sCode : ''}`}
                            data={data}
                            qrcodeValue={`4${data?.articleNo?.split('/')[0]}${data?.articleNo?.split('/')[1]}${data?.priceLabel[selectColor]?.colorCode}`}

                            harmacn={harmacn}
                            homeProducts={homeProducts}
                            renderShape={renderShape(category)}
                            Path1={Path1}
                            x={x}
                            y={y}
                            cardType={cardType}
                            SouthAmerica={SouthAmerica}
                            sizeData={sizeData}
                            indo={data?.priceLabel[0]?.sizes}
                            szrgrp={data?.sizeGroup}
                            inx={index}
       
                            rifd={data.priceLabel[0].rifd}
              />
            )}
            {labelLittle === 'LABEL9 52X90 DUVET' && (
              <PageBigFour
           key={ index}
                            selectColor={selectColor}
                            barcodeValue={`4${data?.articleNo?.split('/')[0]}${data?.articleNo?.split('/')[1]}${data?.priceLabel[selectColor]?.colorCode}${sizeData.sCode ? sizeData.sCode : ''}`}
                            data={data}
                            qrcodeValue={`4${data?.articleNo?.split('/')[0]}${data?.articleNo?.split('/')[1]}${data?.priceLabel[selectColor]?.colorCode}`}

                            harmacn={harmacn}
                            homeProducts={homeProducts}
                            renderShape={renderShape(category)}
                            Path1={Path1}
                            x={x}
                            y={y}
                            cardType={cardType}
                            SouthAmerica={SouthAmerica}
                            sizeData={sizeData}
                            indo={data?.priceLabel[0]?.sizes}
                            szrgrp={data?.sizeGroup}
                            inx={ index}
                   
                            rifd={data.priceLabel[0].rifd}
              />
            )}
          </div>
        ))}
        </div>
      </div>
    )
  }

  // 🔹 Normal render
  const renderNormal = () => {
    const filteredSizes = data.priceLabel[selectColor].sizes.filter((item) => item.amount > 0)

    const labelWidth = 55
    const labelHeight = 95
    const gridWidth = 275
    const gridHeight = 440

    const columns = Math.floor(gridWidth / labelWidth)
    const rows = Math.floor(gridHeight / labelHeight)
    const maxLabels = columns * rows
    const labelsToShow = filteredSizes.slice(0, maxLabels)

    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${columns}, ${labelWidth}mm)`,
          gridTemplateRows: `repeat(${rows}, ${labelHeight}mm)`,
          width: `${gridWidth}mm`,
          height: `${gridHeight}mm`,
          gap: '0mm',
          position: 'relative',
          background: 'white',
          marginLeft: '47px',
          marginTop: '30px',
        }}
      >
        {labelsToShow.map((sizeData, index) => (
          <div
            key={index}
            style={{ width: `${labelWidth}mm`, height: `${labelHeight}mm`, position: 'relative' }}
          >
            <Page1
              selectColor={selectColor}
              sizeData={sizeData}
              inx={index}
              data={data}
              indo={data?.priceLabel[0]?.sizes}
              harmacn={harmacn}
              SouthAmerica={SouthAmerica}
              rifd={data.priceLabel[0].rifd}
            />
          </div>
        ))}
      </div>
    )
  }

  return (
    <div ref={ref}>{bicakIziParams && bicakIziParams.length > 0 ? renderWithParams() : renderNormal()}</div>
  )
}

export default React.forwardRef(L55XPRHOMEH)
